// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type UpdateGroupResponse = SuccessResponse | FailedResponse
type ledger = Partial<LedgerLineItem> & { id: string }
interface UpdateableGroupProperties {
    targetAmount: number
    ledger: ledger | ledger[]
    type: 'fixed' | 'open' | 'both' | 'pending'
}

export class UpdateGroupRequest extends Request {
    private constructor(groupId: string, init?: RequestInit) { super(`${vcBaseUrl}/group/${groupId}`, init) }
    static async init(groupId: string, props: Partial<UpdateableGroupProperties>, init?: RequestInit) {
        return new UpdateGroupRequest(groupId, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(props)
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<UpdateGroupResponse>(await response.json())
        console.info("Update Group Results:", data)

        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}